<template>

    <div class="container mx-auto my-24">

        <div class="flex justify-center items-center relative">

            <div class="absolute h-[75px] w-[75px] rounded-full inset-y-auto -left-24 flex justify-center items-center cursor-pointer bg-neutral-600"
                 :class="cardIndex < props.projects.length - 3 ? 'hover:bg-neutral-400' : ''"
                 @click="moveLeft"
            >

                <svg class="h-6 w-6 stroke-white"
                     xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>

            </div>

            <div class="w-[1536px] h-[500px] overflow-hidden relative">

                <ul class="flex absolute top-0 transition-all duration-700"
                    :style="{left: (-1 * cardIndex * 528) + 'px' }"
                >

                    <Card v-for="project in projects"
                          :project="project"
                          :key="project.id"
                    />

                </ul>

            </div>

            <div class="absolute h-[75px] w-[75px] rounded-full inset-y-auto -right-24 flex justify-center items-center cursor-pointer bg-neutral-600"
                 :class="cardIndex > 0 ? 'hover:bg-neutral-400' : ''"
                 @click="moveRight"
            >

                <svg class="h-6 w-6 stroke-white"
                     xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>

            </div>

        </div>

    </div>

</template>

<script setup>
import { watch, ref, toRef } from "vue"
import Card from "./CarouselCard"

const props = defineProps({
    projects: {
        type: Array,
        default: () => [],
    },
})

let cards = ref([])

let cardIndex = ref(3)

const initialCarousel = () => {
    // if (props.projects.length !== 0){
    //     while (cards.value.length < 3) {
    //         props.projects.forEach(item => {
    //             if (cards.value.length < 3){
    //                 cards.value.push(item)
    //             }
    //         })
    //     }
    // }
}

initialCarousel()

const moveLeft = () => {
    if (cardIndex.value < props.projects.length - 3){
        cardIndex.value++
    } else {
        // cardIndex.value = 0
    }

    // console.log('cardIndex', cardIndex.value)

    // let oldItem = null
    // if (props.projects.length < 4){
    //     oldItem = cards.value.shift()
    //     cards.value.push(oldItem)
    // } else {
    //     let lastIndex = props.projects.indexOf(cards.value[cards.value.length-1])
    //
    //     if (lastIndex + 1 <= props.projects.length - 1){
    //         cards.value.shift()
    //         cards.value.push(props.projects[lastIndex + 1])
    //     } else {
    //         cards.value.shift()
    //         cards.value.push(props.projects[0])
    //     }
    // }
}

const moveRight = () => {
    if (cardIndex.value > 0){
        cardIndex.value--
    } else {
        // cardIndex.value = props.projects.length - 3
    }

    // console.log('cardIndex', cardIndex.value)
    // let oldItem = null
    // if (props.projects.length < 4){
    //     oldItem = cards.value.pop()
    //     cards.value.unshift(oldItem)
    // } else {
    //     let firstIndex = props.projects.indexOf(cards.value[0])
    //
    //     if (firstIndex - 1 >= 0){
    //         cards.value.pop()
    //         cards.value.unshift(props.projects[firstIndex - 1])
    //     } else {
    //         cards.value.pop()
    //         cards.value.unshift(props.projects[props.projects.length - 1])
    //     }
    // }
}

</script>
